import React, { FC } from 'react'

import { IconSettingsProps } from './IconSettings.types'
import * as Styled from './styles/IconSettings.style'

import { nonThemeableRules } from '../../ruleSet'

const IconSettings: FC<IconSettingsProps> = ({
  size = nonThemeableRules.defaultSize as number as IconSettingsProps['size'],
  isResponsive = false,
}: IconSettingsProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='m40.15 27.8-1.9-1.108a3.25 3.25 0 0 1 0-5.542l1.9-1.107c1.583-.95 2.058-2.85 1.108-4.275l-1.583-2.693c-.95-1.582-2.85-2.057-4.275-1.107l-1.9 1.107c-2.057 1.268-4.75-.317-4.75-2.692V8.168A3.177 3.177 0 0 0 25.583 5h-3.165a3.178 3.178 0 0 0-3.168 3.168v2.057c0 2.375-2.692 3.957-4.75 2.693l-1.9-.95a3.07 3.07 0 0 0-4.275 1.107L6.75 15.768a3.45 3.45 0 0 0 1.1 4.432l1.9 1.108c2.058 1.11 2.058 4.274 0 5.384L7.85 27.8c-1.582.95-2.057 2.85-1.107 4.275l1.582 2.692c.95 1.583 2.85 2.058 4.275 1.108l1.9-.95c2.058-1.267 4.75.318 4.75 2.693v2.215A3.177 3.177 0 0 0 22.418 43h3.165a3.177 3.177 0 0 0 3.167-3.167v-2.058c0-2.375 2.693-3.957 4.75-2.692l1.9 1.11a3.071 3.071 0 0 0 4.275-1.11l1.575-2.69c.8-1.743.325-3.643-1.1-4.593Z'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M24 30.332a6.332 6.332 0 1 0 0-12.664 6.332 6.332 0 0 0 0 12.665Z'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconSettings
